import styled from 'styled-components';
import type { RichTextAreaWrapperProps } from '@atlassian/help-center-common-component/rich-text-area-wrapper';
import { getRichTextAreaWrapperStyles } from '@atlassian/help-center-common-component/rich-text-area-wrapper';

// Manual overrides required to theme the editor to look like a request create form field
// eslint-disable-next-line rulesdir/no-styled-export
export const RichTextAreaWrapper = styled.div<RichTextAreaWrapperProps>`
    flex: 1 1 100%;
    ${getRichTextAreaWrapperStyles()}
`;
